import { FormEvent, useState } from "react";
import { reachGoalAiChatSent } from "@/utils/yandexMetrika";

interface Props {
  onAsk: (text: string) => void;
  loading: boolean;
  error: string | null;
  userAuthor: string;
}

export function AskBar({ onAsk, loading, error, userAuthor }: Props) {
  const [input, setInput] = useState("");
  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const text = input.trim();
    if (!text || loading) return;
    reachGoalAiChatSent();
    setInput("");
    onAsk(text);
  }

  return (
    <footer className="ask-bar">
      {error && <p className="ask-bar-error">{error}</p>}
      <form className="ask-bar-form" onSubmit={handleSubmit}>
        <div className="ask-bar-compose">
          <textarea
            className="ask-bar-input"
            rows={2}
            placeholder="Задайте вопрос — ответ появится в ленте…"
            value={input}
            disabled={loading}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
          />
          <button
            type="submit"
            className="btn-send"
            disabled={loading || !input.trim()}
            title="Отправить"
            aria-label="Спросить"
          >
            {loading ? (
              <span className="btn-send-spinner" aria-hidden />
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                <path
                  d="M5 12h12m0 0l-5-5m5 5l-5 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        </div>
      </form>
      <p className="ask-bar-note">
        {userAuthor ? (
          <>
            Вы пишете как <strong>{userAuthor}</strong> · анонимно · ответ по архиву
          </>
        ) : (
          <>Анонимный вопрос · ответ по архиву чата</>
        )}
      </p>
    </footer>
  );
}
